import { render, staticRenderFns } from "./LogsNoData.vue?vue&type=template&id=02c71386&scoped=true"
import script from "./LogsNoData.vue?vue&type=script&lang=js"
export * from "./LogsNoData.vue?vue&type=script&lang=js"
import style0 from "./LogsNoData.vue?vue&type=style&index=0&id=02c71386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c71386",
  null
  
)

export default component.exports